import { css } from '@emotion/react'
import { Flow } from 'bold-ui'

interface HistoricoMChatTwoColumnTableItemProps {
  left: React.ReactNode | undefined | null
  right: React.ReactNode | undefined | null
}

export const HistoricoMChatTwoColumnTableItem = (props: Readonly<HistoricoMChatTwoColumnTableItemProps>) => {
  const { left, right } = props

  const hasLeft = left !== undefined && left !== null
  const hasRight = right !== undefined && right !== null

  if (!hasLeft && !hasRight) return null

  const styles = createStyles(hasRight)

  return (
    <Flow direction='horizontal' gap={1.5} justifyItems='stretch' style={styles.columns}>
      {hasLeft && (
        <Flow direction='vertical' gap={0.5} style={styles.column}>
          {left}
        </Flow>
      )}
      {hasRight && (
        <Flow direction='vertical' gap={0.5} style={styles.column}>
          {right}
        </Flow>
      )}
    </Flow>
  )
}

const createStyles = (hasTwoColumns: boolean) => ({
  columns: css({
    gridAutoColumns: 'unset',
    gridTemplateColumns: hasTwoColumns ? 'minmax(0, 1fr) minmax(0, 1fr)' : '',
    width: '100%',
  }),
  column: css({
    minWidth: 0,
    overflowWrap: 'anywhere',
  }),
})
